import { setCurrentView } from "../../../../redux/assignCourse/actions";
import AssignCourseModal from "../../../modal/AssignCourseModal";
import TagGroup from "../DetailTagGroup/TagGroup";
import AvailableInLPComponent from "./AvailableInLP/AvailableInLPComponent";
import "./RightPanelComponent.scss";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CourseAds from "./CourseAds";
import CONFIG from "../../../../utils/config";

const RightPanelComponent = (props) => {
  const { id, code, type, source, moduleData, parentName, isMobile,isRightPanel,isTagAvailable,from } = props;

  const userRole = useSelector((state) => state.user.role);
  const authBroker = useSelector((state) => state.auth.authBroker);
  console.log("module data--", moduleData, userRole);
  const [show, setShow] = useState(false);
  let dispatch = useDispatch();
  let navigate = useNavigate();

  return (
    <>
      <div className="right-panel">
        {type==="event"?"":(userRole === "manager" &&
          ((!moduleData?.isPaid &&
            moduleData?.purchased_info?.selling_price === 0 && moduleData?.purchased_info?.is_purchased !== true) ||
            source === "broker")) ||
        (userRole === "manager" && (type === "lp" || type === "oblp") && source === "broker") ||
        (userRole === "manager" &&
          (type === "lp" || type === "oblp") && 
          moduleData?.purchased_info?.is_purchased !== true &&
          moduleData?.purchased_info?.selling_price === 0) ? (
          <div className="team-assign-sec  mt-xl-0 mt-5">
            <div className="text-box-rs d-flex align-items-center">
              <div className="img-leftbef">
                <img src="/images/TeamBenefit.svg" />
              </div>
              <div className="benefot">
                <p className="m-0">Get your team to benefit from this course</p>
              </div>
            </div>
            <div className="button-sec-assign mt-3 d-flex gap-2 align-items-center">
              <button
                type="button"
                className="startcourse-btn"
                onClick={() => {
                  dispatch(setCurrentView(1));
                  setShow(true);
                }}
              >
                + Assign
              </button>
              
                <button
                  type="button"
                  className="startcourse-btn"
                  onClick={() => {
                    let parentId = moduleData?.id;
                    let origin =(source === "xsel" || source === "ecom")
                        ? "xsel"
                        : "broker";
                    let pName =  type === "lp" ? "learningpath":type === "oblp" ? "onboardingpath" : parentName
                    navigate(
                      "/assigned-users?parentId=" +
                        parentId +
                        "&origin=" +
                        origin +
                        "&parentName=" + pName + "&isMobile=" +
                        isMobile //isMobile
                    );
                  }}
                >
                  View Assigned
                </button>
              
            </div>
          </div>
        ) : (
          ""
        )}

        {(type ==="course" || type === "video") && authBroker?.payload?.user?.company_id=== CONFIG.C21_COMPANY_ID  &&  <CourseAds type = {type} />}

        <TagGroup {...props} />
        {type === "lp" || type === "oblp" || type === "service" || type === "event" ? (
          ""
        ) : (
          from==="module"?(isRightPanel||isTagAvailable)?<div className="mt-5">
          <AvailableInLPComponent {...props} />
        </div>:""
          :<div className="mt-5">
            <AvailableInLPComponent {...props} />
          </div>
        )}
        {false && <div className="surveryse mt-4">
          <h4 className="surver-title">Survey</h4>

          <ul class="list-unstyled">
            <li class="d-flex align-items-center border p-3 rounded mb-3">
              <img src="https://placehold.co/64x64" alt="Survey Thumbnail" class="rounded me-3" />
              <div className="righ-survery">
                <h5 class="mb-1">Customer Satisfaction Survey</h5>
                <span class="badge bg-succes-act">Active</span>
              </div>
            </li>

            <li class="d-flex align-items-center border p-3 rounded mb-3">
              <img src="https://placehold.co/64x64" alt="Survey Thumbnail" class="rounded me-3" />
              <div className="righ-survery">
                <h5 class="mb-1">Product Feedback Survey</h5>
                <span class="badge bg-warning-d ">Pending</span>
              </div>
            </li>

            <li class="d-flex align-items-center border p-3 rounded mb-3">
              <img src="https://placehold.co/64x64" alt="Survey Thumbnail" class="rounded me-3" />
              <div className="righ-survery">
                <h5 class="mb-1">Employee Satisfaction Survey</h5>
                <span class="badge bg-dangerd">Closed</span>
              </div>
            </li>
          </ul>
        </div>}
      </div>

      <AssignCourseModal
        show={show}
        parentName={type === "lp" ? "Learning Path":type === "oblp"?"Onboarding Path" : parentName}
        parentId={moduleData?.id}
        setShow={setShow}
        origin={( source === "xsel" || source === "ecom")
            ? "xsel"
            : "broker"
        }
        isMobile={isMobile}
      />
    </>
  );
};

export default RightPanelComponent;
